import React, { useEffect, useRef } from 'react';
import { hot } from 'react-hot-loader';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import ExternalVideo from './ExternalVideo';
import LazyImage from '../../hocs/Lazy/LazyImage';
import Slider from '../../hocs/Slider/Slider';
import { imageSizeTranslation } from '../../utils/image';
import { urlifyAllowAccents } from '../../utils/string';
import s from './ProductImages.scss';

const ProductFunctions = ({ index, imageSrc, openZoom }) => {
	const openZoomHandler = () => {
		openZoom(index);
	};

	return (
		<div className={s.productImages_inner_functions}>
			<button className={[s.productImages_inner_function, s.productImages_inner_function__zoom].join(' ')} type="button" aria-label="Zoom image" onClick={openZoomHandler}>
				<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><g fill="none" stroke="#000" strokeLinecap="round" transform="translate(1.186 .815)"><line x1="6.5" x2="6.5" y1="13.5" y2=".5" /><line x2="13" y1="7" y2="7" /></g></svg>
			</button>
			<a className={[s.productImages_inner_function, s.productImages_inner_function__download].join(' ')} href={imageSrc.replace('https://cdn.shopify.com', 'https://www.emeco.net')} target="_blank" rel="noopener noreferrer" aria-label="Download image" download>
				<svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17"><g fill="none" stroke="#000" strokeLinecap="round" transform="translate(0 .63)"><polyline strokeLinejoin="round" points="15.191 7.5 9.5 14.825 3.809 7.5" /><line x1="9.5" x2="9.5" y1="13.5" y2=".5" /><line x1="18.5" x2=".5" y1="15.87" y2="15.87" /></g></svg>
			</a>
		</div>
	);
};

const ProductImages = ({ media, currentVariantKey }) => {
	const lightbox = useRef(null);
	useEffect(() => {
		const arrowSVG = '<svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" fill="black" d="M0.462853 3.82843L3.64483 0.646445C3.8401 0.451183 4.15668 0.451183 4.35194 0.646445L7.53392 3.82843C7.72918 4.02369 7.72918 4.34027 7.53392 4.53553C7.33866 4.73079 7.02208 4.73079 6.82681 4.53553L4.49839 2.20711L4.49839 16H3.49839L3.49839 2.20711L1.16996 4.53553C0.974698 4.73079 0.658115 4.73079 0.462853 4.53553C0.267591 4.34027 0.267591 4.02369 0.462853 3.82843Z"></path></svg>';
		lightbox.current = new PhotoSwipeLightbox({
			arrowPrevSVG: arrowSVG,
			arrowNextSVG: arrowSVG,
			closeSVG: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13" stroke="black"></path><path d="M1 1L13 13" stroke="black"></path></svg>',
			zoomSVG: '',
			gallery: '#productTop',
			children: '.u-galleryImage',
			showHideAnimationType: 'zoom',
			pswpModule: () => import('photoswipe/dist/photoswipe.esm'),
		});
		lightbox.current.init();

		return () => {
			lightbox.current.destroy();
			lightbox.current = null;
		};
	}, []);

	const openZoomHandler = (index) => {
		lightbox.current.loadAndOpen(index);
	};

	return (
		<div className={s.productImages}>
			<div className={[s.productImages_inner, media.length <= 1 ? s.productImages_inner__sliderDisabled : null].join(' ')}>
				{
					media.length > 0 && (
						<Slider adaption="product" key={`slider${currentVariantKey}`} renderOther={ProductFunctions} openZoom={openZoomHandler}>
							{
								media.map((item, i) => {
									if (item.type === 'EXTERNAL_VIDEO') {
										return (
											<figure key={item.src} className={s.productImages_media}>
												<div className={s.productImages_media_image}>
													{ item.type === 'EXTERNAL_VIDEO' && <ExternalVideo url={item.src} uid={urlifyAllowAccents(item.alt)} /> }
												</div>
											</figure>
										);
									}

									return (
										<figure key={item.src} className={s.productImages_media}>
											<a href={item.src} data-pswp-width={item.width} data-pswp-height={item.height} target="_blank" rel="noopener noreferrer" className={['u-galleryImage', s.productImages_media_image].join(' ')}>
												<LazyImage {...imageSizeTranslation('7', item, '_', i === 0 ? 'eager' : 'lazy')} />
											</a>
										</figure>
									);
								})
							}
						</Slider>
					)
				}
			</div>
		</div>
	);
};

export default hot(module)(ProductImages);
